"use strict";
/**
 * @module React Input components
 * Wrapper over all input components
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var pp_react_checkbox_1 = require("@paypalcorp/pp-react-checkbox");
var pp_react_1 = require("@paypalcorp/pp-react");
var input = function (props) {
    var inputElement = null;
    var hasError = props.isInvalid &&
        props.shouldValidate &&
        (props.isTouched || props.IsSubmitted);
    var showError = hasError && (props.isTouched || props.IsSubmitted);
    var errorMessage = props.elementConfig.suggestionText;
    switch (props.elementType) {
        case "input":
            inputElement = (React.createElement("div", null,
                React.createElement(pp_react_1.TextInput, { className: props.className || "textInputMargin", name: props.name || props.id, id: props.id, onChange: props.changed, value: props.value, label: props.elementConfig.label, placeholder: props.elementConfig.placeholder, errorText: showError && errorMessage ? errorMessage : "", disabled: props.isDisabled }),
                props.helperText && (React.createElement(pp_react_1.Text, { size: "sm", className: "newNameChange-input_box_helper_text" },
                    props.helperText,
                    " "))));
            break;
        case "select":
            inputElement = (React.createElement(pp_react_1.Dropdown, { label: props.elementConfig.label, placeholder: props.elementConfig.placeholder, id: props.id, name: props.id, onChange: props.changed, value: props.value, options: props.elementConfig.options.map(function (option) {
                    return {
                        label: option.optionValue,
                        value: option.optionId,
                    };
                }), errorText: hasError && errorMessage ? errorMessage : "" }));
            break;
        case "checkbox":
            inputElement = (
            // issue with pp-react component checkbox with ts: https://github.paypal.com/PayPal-UI-R/pp-react/issues/188
            // @ts-ignore
            React.createElement(pp_react_checkbox_1.Checkbox, { className: props.className, id: props.id, checked: props.value, onChange: props.changed, name: props.id, label: React.createElement(pp_react_1.Text, tslib_1.__assign({ size: props.elementConfig.labelClass }, props.elementConfig.labelSize), props.elementConfig.label) }));
            break;
        case "radio":
            inputElement = (React.createElement(pp_react_1.RadioButton, { id: props.id, label: props.elementConfig.placeholder, name: props.id, className: props.className || "newNameChange-no_left_right_margin", onChange: props.changed, value: props.value, options: props.elementConfig.options.map(function (option) {
                    return {
                        label: option.optionValue,
                        value: option.optionId,
                        checked: props.value === option.Id,
                        helperText: option.optionComment || "",
                    };
                }) }));
            break;
    }
    return inputElement;
};
exports.default = input;
